module.exports = __webpack_public_path__ + "img/star_3.c8223b3e.png";